import { atom } from 'jotai'
import { UnhandledErrorEvent } from './bus'

export type ToastMessage = UnhandledErrorEvent & {
	id: string
	variant: 'error' // Future variants for other types of toasts
	createdAt: number
}

export const toastMessagesAtom = atom<ToastMessage[]>([])

export const appendToastAtom = atom(
	null,
	(get, set, toast: Omit<ToastMessage, 'id' | 'createdAt'> & { id?: string; createdAt?: number }) => {
		const id = toast.id
			?? `t_${Date.now()}_${Math.random().toString(36).slice(2)}`
		const createdAt = toast.createdAt ?? Date.now()
		const record = { id, createdAt, ...toast }
		const next = [...get(toastMessagesAtom), record]
		const limited = next.length > 5 ? next.slice(next.length - 5) : next
		set(toastMessagesAtom, limited)
		return id
	},
)

export const dismissToastAtom = atom(null, (get, set, id: string) => {
	set(
		toastMessagesAtom,
		get(toastMessagesAtom).filter((t) => t.id !== id),
	)
})

export const dismissAllToastsAtom = atom(null, (_get, set) => {
	set(toastMessagesAtom, [])
})
